module.exports = __webpack_public_path__ + "images/category_lp/musical_instrument/new/assessment_achievements/4_50691be55627e517d4b14bf259c49565.png";